export default __webpack_public_path__ + "static/media/bathroom1-before-1024w.e04928c8.png";